var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMathOperations = function SvgIconMathOperations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.207 3.793a1 1 0 0 1 0 1.414L18.664 6.75l1.543 1.543a1 1 0 0 1-1.414 1.414L17.25 8.164l-1.543 1.543a1 1 0 0 1-1.414-1.414l1.543-1.543-1.543-1.543a1 1 0 0 1 1.414-1.414l1.543 1.543 1.543-1.543a1 1 0 0 1 1.414 0M3.75 5.75a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zM6.75 13.25a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1M13.25 15.384a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1M14.25 18.116a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconMathOperations;